export default "__VITE_ASSET__D8x35_7E__"